<!-- ══ Export Quote / Export Invoice / Export Consumable Summary ═══════════════
     console-v2's Export dialog (quote-detail's `.confirm` "Export Quote") on the
     shared Pebbl shell. Every validator, message and call is the legacy
     modal's - `emailForm` (`email_type` + `oldEmail` + the `emails` FormArray),
     `exportQuote()`, `copyQuoteInvoiceLink()`, `downloadPDF()`, `isLoading`, and
     the `ngbActiveModal.close()` result every caller reads. The address rows
     follow v2: up to 3 in all, each with its own tick (unticked = not sent). -->
<app-pebbl-modal
  [title]="quoteModel.type == 'O'
    ? (isConsumableSummaryExportPopupOn ? 'Export Invoice' : 'Export Consumable Summary')
    : (quoteModel.type == 'Q' && isConsumableSummaryExportPopupOn ? 'Export Quote' : '')"
  [subtitle]="isConsumableSummaryExportPopupOn
    ? 'Send this ' + (quoteModel.type == 'O' ? 'invoice' : 'quote') + ' as a link to up to 3 email addresses, or download the PDF.'
    : 'Send this consumable summary as a PDF to up to 3 email addresses.'">

  <button pm-head-act type="button" class="pm-head-act" aria-label="Close" (click)="ngbActiveModal.close()">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M18 6L6 18M6 6l12 12"/>
    </svg>
  </button>

  <!-- `.qex-body` keys this dialog's 440 width and the v2 checkbox in styles.css;
       `.loader-parent` lets the legacy loader cover the form and the buttons. -->
  <div class="qex-body loader-parent">
    <div class="page-loader" [ngClass]="{'d-none': !isLoading}"></div>

    <form [formGroup]="emailForm">
      <!-- The record's contact. The tick is `email_type`: unticked, this address
           is not sent to and its validators come off (onFirstCheck). -->
      <div class="field">
        <span>Email address 1</span>
        <div class="qex-line">
          <input type="checkbox" name="email_type" formControlName="email_type" value="1"
                 aria-label="Send to this address" (click)="onFirstCheck($event)">
          <input type="email" name="email_type" id="main_email" formControlName="oldEmail"
                 placeholder="name@company.com" aria-label="Email address 1"
                 [class.is-invalid]="((emailForm.controls['oldEmail'].invalid && emailForm.controls['oldEmail'].touched || submitted) || f.oldEmail.errors?.apiError) && !!f.oldEmail.errors">
        </div>
        @if (((emailForm.controls['oldEmail'].invalid && emailForm.controls['oldEmail'].touched || submitted) || f.oldEmail.errors?.apiError) && f.oldEmail.errors) {
          <span class="field-error" role="alert">
            @if (f.oldEmail.errors?.required) { <span>Enter the email address.</span> }
            @if (f.oldEmail.errors?.pattern) { <span>Enter the valid email address.</span> }
            @if (f.oldEmail.errors?.apiError) { <span>{{ f.oldEmail.errors?.apiError }}</span> }
          </span>
        }
      </div>

      <!-- Added addresses - the `emails` FormArray. Each row has its own tick
           (`checked`), as in console-v2; unticked, it is not sent or validated. -->
      <ng-container formArrayName="emails">
        @for (value of emailsArray().controls; track value; let idx = $index) {
          <div class="field" [formGroupName]="idx">
            <span>Email address {{ idx + 2 }}</span>
            <div class="qex-line">
              <input type="checkbox" formControlName="checked"
                     aria-label="Send to this address" (change)="onAddedCheck(idx, $event)">
              <input type="email" formControlName="email" placeholder="name@company.com"
                     [attr.aria-label]="'Email address ' + (idx + 2)"
                     [class.is-invalid]="((fe?.controls[idx].get('email')?.invalid && (fe?.controls[idx].get('email').touched || submitted)) || fe?.controls[idx].get('email')?.errors?.apiError) && !!fe?.controls[idx].get('email')?.errors">
            </div>
            @if (((fe?.controls[idx].get('email')?.invalid && (fe?.controls[idx].get('email').touched || submitted)) || fe?.controls[idx].get('email')?.errors?.apiError) && fe?.controls[idx].get('email')?.errors) {
              <span class="field-error" role="alert">
                @if (fe?.controls[idx].get('email')?.errors?.required) { <span>Enter the email address.</span> }
                @if (fe?.controls[idx].get('email')?.errors?.pattern) { <span>Enter the valid email address.</span> }
              </span>
            }
          </div>
        }
      </ng-container>

      @if (canAddEmail()) {
        <button type="button" class="qex-add" (click)="addNewEmail()">＋ Add another address</button>
      }
      <span class="error invalid-feedback d-none" id="error_recipient_email_address"></span>
    </form>

    <!-- console-v2's foot: Copy link · Download PDF · the primary export. In the
         consumable-summary mode only the export shows, as before. -->
    <div class="pm-foot qex-foot">
      @if (isConsumableSummaryExportPopupOn) {
        <button type="button" class="btn-secondary"
                (click)="copyQuoteInvoiceLink(true); $event.stopImmediatePropagation();">Copy link</button>
        <button type="button" class="btn-secondary" (click)="downloadPDF()">Download PDF</button>
      }
      <button type="button" class="btn-primary" (click)="exportQuote()">
        {{ getExportButtonName() }}
        @if (isConsumableSummaryExportPopupOn) {
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/>
          </svg>
        }
      </button>
    </div>
  </div>
</app-pebbl-modal>
